<template>
  <div  :class="{english:$i18n.locale=='en'}">
    <headLine ref="dialog" :showbar="showmenu_bar" @on-locale-change="onLocaleChange" index="11">
      {{$t('join.name')}}
    </headLine>
<!--     <div class="menu_toolbar2 center" :class="{menu_toolbar:!showmenu_bar}">
      <router-link to="/about" style="color:rgba(255,255,255,0.5)" v-html="$t('join.text16')"></router-link>
      <router-link to="/join" v-html="$t('join.name')"></router-link>
    </div> -->
     <div class="banner">
         <img v-lazy="imglist[0]" alt="">    
         <h1 class="banner_title">
<!--            让每个人都能享受
           <div style="margin-top:0.2rem">
             VR直播的乐趣
           </div> -->
         </h1>
     </div>
     <div class="content center">
       <div class="content_item" style="margin-bottom:0.7rem">
        <ul class="about_list clearfix">
          <li class="about_item">
            <div class="about_item1">
              <span class="about_item_icon"></span>
            </div>
            <div class="about_item_title" v-html="$t('join.text6')">
            </div>
            <div class="vr_cloud_box_split"></div>
            <div class="about_item_text" style="margin-bottom:0.15rem" v-html="$t('join.text7')">
                <!-- 扁平化管理 -->
            </div>
<!--             <div class="about_item_text" >
              弹性工作时间
            </div> -->
          </li>
          <li class="about_item">
            <div class="about_item2">
              <span class="about_item_icon"></span>
            </div>
            <div class="about_item_title" v-html="$t('join.text10')">
              <!-- 欢乐 -->
            </div>
            <div class="vr_cloud_box_split"></div>
            <div class="about_item_text" style="margin-bottom:0.15rem" v-html="$t('join.text11')">
                <!-- 灵活办公，定期团建 -->
            </div>
<!--             <div class="about_item_text" >
                带薪休假10-15天
            </div> -->

          </li>
          <li class="about_item">
            <div class="about_item3">
              <span class="about_item_icon"></span>
            </div>
            <div class="about_item_title" v-html="$t('join.text8')">
              <!-- 成长 -->
            </div>
            <div class="vr_cloud_box_split"></div>
            <div class="about_item_text" style="margin-bottom:0.15rem" v-html="$t('join.text9')">
                <!-- 导师培养机制 -->
            </div>
<!--             <div class="about_item_text" >
                赴美交流机会
            </div> -->
          </li>
        </ul>
       </div>
       <div class="content_item"  style="background:#f4f8fc">
          <h3 class="content_item_title" v-html="$t('join.text12')">
          </h3>
          <img v-lazy="imglist[1]" alt="" style="width:7.5rem;height:3.12rem" v-if="$i18n.locale=='ch'">
          <img v-lazy="imglist[4]" alt="" style="width:7.5rem;height:3.12rem" v-if="$i18n.locale=='en'">
       </div>
       <div class="content_item">
          <h3 class="content_item_title" v-html="$t('join.text14')">
          </h3>
          <img v-lazy="imglist[2]" alt="" style="width:7.5rem;height:5.45rem" v-if="$i18n.locale=='ch'">
          <img v-lazy="imglist[5]" alt="" style="width:7.5rem;height:5.45rem" v-if="$i18n.locale=='en'">
       </div>
       <div class="content_item" v-if="$i18n.locale=='ch'">
          <h3 class="content_item_title">
            热招职位
          </h3>
          <dl class="job_list">
            <dt style="margin-top:0.4rem">
              视频算法工程师
            </dt>
            <dd class="job_text">
              25k-50k / 深圳 / 经验5-10年 / 本科及以上 / 全职
            </dd>
            <dd>
              <a href="https://www.lagou.com/jobs/3419777.html" class="button_default2" target="_blank">查看职位</a>
            </dd>
            <dt>
              Android客户端开发工程师
            </dt>
            <dd class="job_text">
              18k-30k / 深圳 / 经验3-5年 / 本科及以上 / 全职
            </dd>
            <dd>
              <a href="https://www.lagou.com/jobs/2642148.html" class="button_default2" target="_blank">查看职位</a>
            </dd>
            <dt>
              高级产品运营经理（2B方向)
            </dt>
            <dd class="job_text">
              18k-30k / 深圳 / 经验5-10年 / 学历不限 / 全职
            </dd>
            <dd>
              <a href="https://www.lagou.com/jobs/2949766.html" class="button_default2" target="_blank">查看职位</a>
            </dd>
          </dl>
          <div class="content_item content_bg" v-lazy:background-image="imglist[3]" style="padding-top:0">
           <div class="center" style="padding-top:0.2rem;">
              <a href="https://www.lagou.com/gongsi/j149944.html" target="_blank" style="font-size:0.24rem;color:rgb(35,138,247);text-decoration:underline;" >查看更多职位</a>
           </div>
         </div>
       </div>
       <div class="content_item" v-if="$i18n.locale=='en'">
          <h3 class="content_item_title">
            Open Positions
          </h3>
          <dl class="job_list">
            <dt style="margin-top:0.4rem">
              Sr. Software Engineer (Millbrae, CA)
            </dt>
          </dl>
          <div class="content_item content_bg" v-lazy:background-image="imglist[3]" style="padding-top:0;padding-bottom:0.5rem">
           <div class="center" style="padding-top:0.2rem;">
              <a href="mailto:hr@vrviu.com" target="_blank" class="button_default2" >Apply Now</a>
           </div>
         </div>
       </div>
     </div>
     <footerLine></footerLine>
  </div>
</template>

<script>
import headLine from "./header"
import footerLine from "./footer"
import Vue from 'vue'; 
import i18n from '../common/i18n'

export default {
  i18n:i18n,
  data(){
    return{
      imglist:[
        "/static/images/about/T.png",
        "/static/images/join/image.png",
        "/static/images/join/image2.png",
        "/static/images/about/bg.png",
        "/static/images/about/bg11.png",
        "/static/images/about/bg12.png"
      ],
      showmenu_bar:true
    }
  },
  created(){
    var self = this;
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
    // document.addEventListener("scroll",function(){
    //   var scrollTop = document.body.scrollTop;
    //       if(scrollTop>10){
    //         if(scrollTop>=self.scrollTop){
    //             self.showmenu_bar = false;
    //         }else{
    //             self.showmenu_bar = true;
    //         }
    //           setTimeout(function(){self.scrollTop = scrollTop;},100); 
    //       }
    // },false)
  },
  components:{
    headLine,
    footerLine
  },
  methods:{
    swipeup(){
      this.showmenu_bar=false
    },
    swipedown(){
      this.showmenu_bar=true
    },
      onLocaleChange:function(val){
        this.$i18n.locale=val;
      }
  }
}
</script>

<style scoped>

.job_list dt{
  font-size: 0.28rem;
  color:rgb(40,40,40);
  margin-top: 0.76rem;
  font-weight:bold;


}
.english .job_list dt{
  font-weight:normal;
  margin-bottom: 0.3rem;
}
.job_list dd{
  line-height: 0
}
.job_list .job_text{
  font-size: 0.24rem;
  color:rgb(114,114,114);
  margin: 0.3rem 0 0.4rem 0;
}
.content_bg{
  height: 2.78rem;
}
/*.about_list{
  margin-top: 1rem;
  margin-bottom: 1.78rem;
}*/
.about_item{
  float: left;width: 33.3%;
}
.english .about_item_title{
  font-family: Quicksand Regular
}
.about_item_title{
  font-size: 0.36rem;
  color:rgb(40,40,40);
  margin: 0.4rem 0 0 0;
}
.about_item1,.about_item2,.about_item3{
  line-height: 0
}
.english .about_item_text{
  font-size: 0.22rem;
}
.about_item_text{
  line-height:1.5em;

  font-size: 0.24rem;
  color:rgb(80,80,80);
}
.about_item_icon{
  width: 0.8rem;
  height: 0.8rem;
  display: inline-block;
  background: url(../assets/images/join/time.png) no-repeat;
  background-size: contain;
}
.english .about_item_icon{
  background-image: url(../assets/images/join/image11.png)
}
.about_item2 .about_item_icon{
  background: url(../assets/images/join/happy.png) no-repeat;
  background-size: contain;
}
.english .about_item2 .about_item_icon{
  background-image: url(../assets/images/join/image12.png)
}
.about_item3 .about_item_icon{
  background: url(../assets/images/join/tree.png) no-repeat;
  background-size: contain;
}
.english .about_item3 .about_item_icon{
  background-image: url(../assets/images/join/image13.png)
}
/*.about_list{
  margin-top: 1rem;
  margin-bottom: 1.78rem;
}*/
</style>



// WEBPACK FOOTER //
// join.vue?8037807e